/**
 * @generated SignedSource<<e2c2b70874de6dc2bba9763a80422ae9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptModal_viewer$data = {
  readonly account: {
    readonly __typename: "Account";
    readonly allowRecapDownload: boolean;
    readonly allowRecapEngagementStats: boolean;
    readonly id: string;
    readonly logo?: string;
    readonly name?: string;
  };
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly videoPlaybackSettings: {
    readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_viewer" | "MeetingContainerModalNote_viewer" | "MeetingPhaseContext_viewer" | "NoteHeader_viewer" | "StatsPanel_viewer" | "TranscriptPanel_Transcript_viewer">;
  readonly " $fragmentType": "TranscriptModal_viewer";
};
export type TranscriptModal_viewer$key = {
  readonly " $data"?: TranscriptModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPublic"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserVideoPlaybackSettings",
      "kind": "LinkedField",
      "name": "videoPlaybackSettings",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranscriptVideo_videoPlaybackSettings"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "condition": "isPublic",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "logo",
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapDownload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRecapEngagementStats",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HighlightsPanel_viewer"
    },
    {
      "condition": "isPublic",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingContainerModalNote_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NoteHeader_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MeetingPhaseContext_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TranscriptPanel_Transcript_viewer"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StatsPanel_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "eb136eadad3333f502b4cf47add56e8f";

export default node;
